<template>
  <div id="new-busi-form">
    <div v-if="!openHbShow">
      <div class="new-head">
        <div class="head-left">
          <img src="/images/titleLogo.png">
          <!-- <svg-icon style="font-size:44px" icon-class="wf_form" /> -->
          <div class="head-title">
            <span>业务类型：</span>
            <span>{{ vo.flSubject }}</span>
          </div>
        </div>
        <div class="head-right">
          <el-button @click="close">
            <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
            关闭
          </el-button>
        </div>
      </div>
      <div class="busi-box">
        <div class="busi-content">
          <div>
            <div style="text-align: center; font-size: 24px; height: 60px; line-height: 60px">{{ vo.flSubject }}</div>
            <div style="text-align: center; font-size: 14px">时间：{{ formatDateTime(vo.startTime) }} 地点：{{ vo.meetPlace }}</div>
            <div style="height: 40px; line-height: 40px; font-size: 14px">
              <!-- <div v-html="$tx('hygl.components.agendaArrangement', { num: tableData.length, time: formatDuration(allTime) })"></div> -->
              议题安排：<span style="color: #1a82e3;font-size: 18px;margin-right: 4px;">{{ tableData.length }}项</span>议题，时长约 <span style="color: #1a82e3;font-size: 18px;">{{ formatDuration(allTime) }}</span>
            </div>
          </div>
          <div v-loading="loading">
            <el-table ref="tableData" :data="tableData" border row-key="date" class="draggable-table" :max-height="contentHeight" style="width: 100%" @row-click="rowClick" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection" width="55" />
              <el-table-column type="index" :label="'序号'" width="50" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.$index + 1 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="subject" :label="'议题'"></el-table-column>
              <el-table-column prop="mainDept" :label="'主办部门'" width="100" align="center" />
              <el-table-column prop="reportPersonName" :label="'陈述人'" width="90" align="center" />
              <el-table-column prop="startTime" :label="'开始时间'" width="230" align="center" />
              <el-table-column prop="reportTime" :label="'陈述时间/分钟'" width="110" align="center" />
              <el-table-column prop="talkTime" :label="'讨论时间/分钟'" width="110" align="center" />
              <el-table-column prop="meetingStatus" :label="'状态'" width="80" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.meetingStatus == 0 ? '未上会' : scope.row.meetingStatus == 1 ? '已上会' : '待上会' }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="" :label="'附件'" width="70" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.passenger.attachments.length }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="caozuo" :label="'操作'" width="100" align="center">
                <template slot-scope="scope">
                  <div style="display: flex; justify-content: space-evenly; color: #1a82e3">
                    <span v-if="listType==='history' || !canEdit" @click="startHb(scope.row, 'history')">查看汇报</span>
                    <span v-else>
                        <span v-if="scope.row.meetingStatus == 1" @click="startHb(scope.row, 'ready')">查看汇报</span>
                        <span v-else @click="startHb(scope.row)">开始汇报</span>
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 通用弹框 -->
      <select-dialog />
      <!-- 个别模块需要打开表单 -->
      <Basicform v-if="showForm" :title="formTitle" :win-width="moduleInfoT.winWidth" :win-height="moduleInfoT.winHeight" :module-code="moduleInfoT.moduleCode" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
        <template #default="slotProps">
          <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfoT" />
        </template>
      </Basicform>

      <el-dialog :title="listType==='history'?'查看汇报':'开始汇报'" :visible.sync="dialogVisible" width="800px">
        <div style="height: 300px; text-align: center">
          <div>
            <div style="font-size: 18px; height: 60px; line-height: 60px">{{ vo.flSubject }}</div>
            <div style="font-size: 24px; height: 70px">{{ hyytRow.subject }}</div>
            <div style="height: 60px; line-height: 60px; font-size: 14px; color: #1a82e3">陈述人：{{ hyytRow.reportPersonName }}&nbsp;&nbsp;陈述时间：{{ hyytRow.reportTime }}分钟</div>
            <div style="margin-top: 20px">
              <el-button type="primary" @click="openHbFn(1)">确认开始</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <div v-else class="content" style="height: 100%">
      <div v-loading="contentLoading" style="height: 100%;width:100%;">
        <div class="new-head" style="margin-bottom: 10px">
          <div class="head-left" style="margin-left: -15px;">
            <div style="color: #333; font-size: 16px; font-weight: 700" class="head-title">{{ currentIndex+1 }}、{{ hyytRow.subject }}</div>
          </div>
          <div class="head-right">
            <el-button :disabled="isLastBtn" @click="changeHandler('last')">
              <svg-icon style="margin-right: 5px" :style="{ color: isLastBtn ? '#999' : '#3788d8'}" icon-class="last_yt" />上个议题
            </el-button>
            <el-button :disabled="isNextBtn" @click="changeHandler('next')">
              <svg-icon style="margin-right: 5px" :style="{ color: isNextBtn ? '#999' : '#3788d8'}" icon-class="next_yt" />下个议题
            </el-button>
            <el-button @click="stopOrClose">
              <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />关闭
            </el-button>
          </div>
        </div>

        <div style="height: 100%; display: flex">
          <div :style="{'left':isZkzd?'275px':'0px','transform': isZkzd?'rotate(180deg)':'rotate(0deg)'}" style="z-index: 1;position: absolute;top: 50%;transform: translateY(-50%);width: 36px;height: 30px;line-height: 50px;color: #fff;text-align: center;border-radius: 50%;" @click="zkzdFn">
            <svg-icon style="font-size: 50px;color: var(--subjectColor);" icon-class="hygl_hyhb_on_right" />
            <!-- <img style="width: 100%;height: 100%;" src="../../imgs/zkzd.png" alt=""> -->
          </div>
          <transition name="slide-fade">
            <div v-show="isZkzd" style="height: calc(100% - 78px); background: #F0EEEF; position: relative; border-right: 1px solid #ccc">
                <div class="box">
                <div style="height: 40px; line-height: 40px; padding: 0px 15px" class="header">
                    议题材料及附件({{ attachmentsList.length }})
                    <i class="el-icon-refresh" style="font-size: 16px; margin-left: 5px; cursor: pointer" @click="attachRefresh"></i>
                </div>
                <template v-if="attachmentsList.length">
                    <div v-for="(item, index) in attachmentsList" :key="index" :class="changeIdx === index ? 'changeClass' : ''" class="attach_son" @click="attachmentClick(item, index)">
                    <div style="display: flex;line-height: 20px;min-height: 50px;align-items: center;padding: 5px 0;">{{ item.fileName }}</div>
                    </div>
                </template>
                <div v-else style="text-align: center" else class="attach_son">暂无附件</div>
                <!-- 计时器 -->
                <div v-if="canEdit" class="time" @click="pause(1)">
                    <div style="height: 40px; line-height: 52px;color: #999;font-size: 13px;">汇报时长</div>
                    <template v-if="listType==='history'">
                    <div style="font-size: 22px; font-weight: 700;color: var(--subjectColor)">{{ hyytRow.sjReportTime?hyytRow.sjReportTime:'未汇报' }}</div>
                    <div v-if="!reportNotExceeded" style="height:34px;line-height:26px;color:#333;font-size:13px;">未超时</div>
                    <div v-else style="height:34px;line-height:26px;color:red;font-size:13px;">已超时</div>
                    </template>
                    <template v-else>
                    <div v-if="pauseBtn" style="color: #ffa500;">开始汇报</div>
                    <div v-else style="font-size:22px;font-weight:700;color: var(--subjectColor);" :style="{'color': isPaused?'#ffa500':'#1A82E3'}">{{ formattedTime }}</div>
                    <!-- <div style="font-size:22px;font-weight:700;color: #BF165E;" :style="{'color': isPaused?'#ffa500':'#1A82E3'}">{{ formattedTime }}</div> -->
                    <div v-if="!reportNotExceeded" style="height:40px;line-height:26px;color:#333;font-size:13px;">未超时</div>
                    <div v-else style="height:40px;line-height:26px;color:red;font-size:13px;">已超时</div>
                    </template>
                </div>
                </div>
            </div>
          </transition>
          <div id="bodyfilebox" class="bodyfile-container" style="height: calc(100% - 78px); background: #fff" :style="{'width': isZkzd ? 'calc(100% - 300px)' : '100%'}">
            <iframe v-if="judgeFile && bodyFileUrl" id="pdfHtml" width="100%" height="100%" frameborder="0" scrolling="yes" :src="bodyFileUrl" />
            <div v-else style="text-align: center; padding-top: 200px">
              <div>
                <img style="margin-right: 30px; width: 140px" src="/images/w-imgs/hygl/nomessage.png" alt="">
              </div>
              <div v-if="attachmentsList.length" style="margin: 20px 0; color: #333; font-size: 14px">该文件格式不支持在线预览，可下载后本地查看</div>
              <div v-else style="margin: 20px 0; color: #333; font-size: 14px; margin-right: 25px">暂无附件</div>
              <div v-if="attachmentsList.length">
                <el-button style="width: 70px; height: 32px; background: #1a82e3; border: none; margin-right: 30px" type="info" @click="downloadFile(bodyFileUrl)">下载</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            changeIdx: 0,
            dialogVisible: false,
            moduleInfo: {},
            title: '2024年3月工作会议通知',
            tableData: [],
            hyapId: null,
            openHbShow: false,
            bodyFileUrl: '',
            judgeFile: true, // 是否支持预览
            currentFileId: '', // 当前预览附件的id
            attachmentsList: [],
            currentTime: null,
            isPaused: false, // 是否暂停，true为暂停，false为开始
            pauseTime: null,
            intervalId: null,
            hyytRow: {},
            vo: {},
            allTime: 0,
            minutes: 0,
            updateType: 0, // 是否调用接口  0 默认不调用  1 调用
            listType: 'view', // 列表类型  history：历史会议
            contentHeight: '',
            currentIndex: 0, //  当前选中的议题
            scrollTop: 0, // 滚动条位置
            loading: false,
            contentLoading: false,
            isLastBtn: false,
            isNextBtn: false,
            pauseBtn: false, // 显示开始汇报按钮
            tyPauseTime: 0, // 切换议题 的 汇报时间戳
            isZkzd: true,
            canEdit: 1 // 是否可编辑
        }
    },
    computed: {
        formattedTime() {
            if (!this.currentTime) return '00:00'

            const minutes = Math.floor(this.currentTime / 60)

            let seconds = this.currentTime % 60

            if (seconds < 10) {
                seconds = '0' + seconds
            }

            // 不在这里修改 this.minutes
            return `${minutes}:${seconds}`
        },
        // 计算属性来判断是否超时
        reportNotExceeded() {
            if (this.listType === 'history') {
                if (!this.hyytRow.sjReportTime) return false
                var reportTime = this.hyytRow.reportTime
                var minutes = this.hyytRow.sjReportTime.split(':')[0]
                var seconds = 0 + '.' + this.hyytRow.sjReportTime.split(':')[1]

                return reportTime <= Number(minutes) + Number(seconds)
            } else {
                return this.hyytRow.reportTime <= this.minutes
            }
        }
    },
    watch: {
        currentTime(newVal) {
            this.updateMinutes()
        }
    },
    created() {
        this.hyapId = this.$route.query.hyapId
        // this.vo = JSON.parse(this.$route.query.row)
        var data = sessionStorage.getItem('hyapJSON')
        if (data !== null) {
            this.vo = JSON.parse(data)
        }
        if (this.$route.query.type) {
            this.updateType = Number(this.$route.query.type)
        }
        if (this.$route.query.list) {
            this.listType = this.$route.query.list
        }
        if (this.$route.query.canEdit) {
            this.canEdit = Number(this.$route.query.canEdit)
        }
        console.log('this.canEdit', this.canEdit)
        // this.listType = 'view'

        this.getListData()
        this.updateMinutes()
        window.addEventListener('resize', this.onresize, false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onresize, false)
    },
    mounted() {
        this.onresize()
    },
    methods: {
        zkzdFn() {
            this.isZkzd = !this.isZkzd
        },
        onresize() {
            this.loading = true
            if (!document.getElementsByClassName('busi-content')) {
                this.onresize()
                return
            }
            setTimeout(() => {
                this.loading = false
                var offsetHeight = document.getElementById('new-busi-form').offsetHeight

                this.contentHeight = offsetHeight - 250
            }, 50)
        },
        updateMinutes() {
            if (this.currentTime) {
                this.minutes = Math.floor(this.currentTime / 60)
            }
        },
        formatDuration(totalMinutes) {
            const hours = Math.floor(totalMinutes / 60)
            const remainingMinutes = totalMinutes % 60

            return `${hours}小时${remainingMinutes}分钟`
        },
        formatDateTime(inputStr) {
            const dateObj = new Date(inputStr)

            const year = dateObj.getFullYear()
            const month = ('0' + (dateObj.getMonth() + 1)).slice(-2) // 月份从0开始，需要加1并补零
            const day = ('0' + dateObj.getDate()).slice(-2) // 补零处理

            const weekDay = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][dateObj.getDay()]

            const hour = dateObj.getHours()
            const ampm = hour >= 12 ? '下午' : '上午'
            // const formattedHour = hour % 12 || 12 // 转换为12小时制，并处理中午12点的情况
            const formattedHour = hour

            return `${year}年${month}月${day}日（${weekDay}）${ampm}${formattedHour}:00`
            // return this.$tx('hygl.components.formatTime', { year, month, day, weekDay, ampm, formattedHour })
        },
        async stopOrClose() {
            if (this.listType !== 'history') {
                if (!this.pauseBtn) {
                    this.hyytRow.meetingStatus = 1
                    this.formattedTime ? this.hyytRow.sjReportTime = this.formattedTime : this.hyytRow.sjReportTime = null
                    // this.hyytRow.status = 0
                    // this.hyytRow.sjReportTime = null
                    this.$http({
                        method: 'put',
                        url: 'hygl/ytRecord/update',
                        data: this.hyytRow,
                        params: { hyapId: this.hyapId }
                    }).then((res) => {
                        if (res.code === 'success') {
                        // do nothing
                        }
                    })
                }
            }

            this.isPaused = false
            this.tyPauseTime = 0
            this.pauseTime = 0
            this.currentTime = 0
            clearInterval(this.intervalId)
            this.openHbShow = false

            this.$nextTick(() => {
                this.dialogVisible = false

                if (this.$refs.tableData.$refs.bodyWrapper !== undefined) {
                    setTimeout(() => {
                        this.$refs.tableData.$refs.bodyWrapper.scrollTop = this.scrollTop
                    }, 100)
                }
            })
        },
        async pause(pauseBtn = 0) {
            var _this = this
            if (pauseBtn > 0) {
                this.pauseBtn = false
                if (this.listType !== 'history') {
                    this.hyytRow.meetingStatus = 1
                    this.hyytRow.sjReportTime = this.formattedTime
                    this.$http({
                        method: 'put',
                        url: 'hygl/ytRecord/update',
                        data: this.hyytRow,
                        params: { hyapId: this.hyapId }
                    }).then((res) => {
                        if (res.code === 'success') {
                            // do nothing
                        }
                    })
                }
            }

            if (this.pauseBtn) return
            this.isPaused = !this.isPaused

            if (this.tyPauseTime > 0) { // 切换议题的计时
                if (!this.isPaused) {
                    if (!this.currentTime) {
                        this.currentTime = this.tyPauseTime
                    }

                    this.intervalId = setInterval(() => {
                        this.currentTime++
                    }, 1000)
                } else {
                    this.pauseTime = this.currentTime

                    clearInterval(this.intervalId)
                }
            } else { // 正常计时
                if (!this.isPaused) {
                    this.currentTime = this.pauseTime

                    this.intervalId = setInterval(() => {
                        this.currentTime++
                    }, 1000)
                } else {
                    this.pauseTime = this.currentTime

                    clearInterval(this.intervalId)
                }
            }
        },
        attachmentClick(attach, index) {
            this.judgeFile = this.JudgeFileType(attach.fileName)
            this.currentFileId = attach.id
            this.changeIdx = index
            let fileurl = process.env.VUE_APP_BASE_API + `/hygl/ytRecord/downloadById?inline=true&attachIds=${attach.id}` + '&widthType=pageWidth&viewType=mobile'
            fileurl += '&httpPort=' + location.port + '&fileName=' + attach.fileName + '&topdf=true'
            this.bodyFileUrl = './plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl) + '&showDownLoadBtn=true'
        },
        async openHbFn(startType = 0) {
            var _this = this
            clearInterval(this.intervalId)
            this.changeIdx = 0
            this.bodyFileUrl = ''
            if (this.attachmentsList.length > 0) {
                this.judgeFile = this.JudgeFileType(this.attachmentsList[0].fileName)
                this.currentFileId = this.attachmentsList[0].id
                let fileurl = process.env.VUE_APP_BASE_API + `/hygl/ytRecord/downloadById?inline=true&attachIds=${this.attachmentsList[0].id}` + '&widthType=pageWidth&viewType=mobile&topdf=true'
                fileurl += '&httpPort=' + location.port + '&fileName=' + this.attachmentsList[0].fileName
                this.bodyFileUrl = './plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl) + '&showDownLoadBtn=true'
            } else {
                this.judgeFile = false
            }
            this.controlBtn()

            console.log('this.hyytRow', this.hyytRow)

            this.tyPauseTime = this.hyytRow.sjReportTime ? this.getReportTime(this.hyytRow.sjReportTime) : 0
            this.currentTime = this.tyPauseTime
            if (this.hyytRow.meetingStatus !== 1) { // 未上会
                this.isPaused = true
                this.pauseBtn = false
                this.pause(0)
            } else {
                this.isPaused = false
                this.pauseBtn = false
                this.pause(0)
            }
            if (startType == 1) {
                this.hyytRow.meetingStatus = 1
                this.$http({
                    method: 'get',
                    url: 'hygl/ytRecord/getById?id=' + this.hyytRow.id
                }).then(resp => {
                    if (resp.code === 'success') {
                        const obj = resp.body.vo
                        obj.meetingStatus = 1
                        if (!obj.upMeetingTime) obj.upMeetingTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                        this.$http({
                            method: 'put',
                            url: 'hygl/ytRecord/update',
                            data: obj
                        }).then((res) => {
                            if (res.code === 'success') {
                            // do nothing
                            // this.getListData()
                            }
                        })
                    }
                })
            }
            this.openHbShow = true
        },
        // 校验附件预览格式
        JudgeFileType(name) {
            var temp = name.split('.')
            temp = temp[temp.length - 1]

            if (['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pdf'].includes(temp)) {
                return true
            }
            return false
        },
        startHb(row, type = 'view') {
            var index = this.tableData.indexOf(row)
            this.currentIndex = index

            if (this.$refs.tableData.$refs.bodyWrapper !== undefined) {
                this.scrollTop = this.$refs.tableData.$refs.bodyWrapper.scrollTop
            }

            if (type === 'view') {
                this.hyytRow = row
                this.attachmentsList = row.passenger.attachments
                this.dialogVisible = true
            } else {
                this.hyytRow = row
                this.attachmentsList = row.passenger.attachments
                this.openHbFn(1)
            }
        },
        rowClick(row, column, event) {
            if (column.property === 'caozuo') return
            var index = this.tableData.indexOf(row)
            this.currentIndex = index

            if (this.$refs.tableData.$refs.bodyWrapper !== undefined) {
                this.scrollTop = this.$refs.tableData.$refs.bodyWrapper.scrollTop
            }

            if (this.listType === 'view') {
                this.hyytRow = row
                if (this.hyytRow.meetingStatus == 1) {
                    this.attachmentsList = row.passenger.attachments
                    this.openHbFn(1)
                } else {
                    this.attachmentsList = row.passenger.attachments
                    this.dialogVisible = true
                }
            } else {
                this.hyytRow = row
                this.attachmentsList = row.passenger.attachments
                this.openHbFn()
            }
        },
        // 刷新议题
        async attachRefresh() {
            this.contentLoading = true
            const param = {
                urlsearch: `meetDirectoryId:${this.vo.ytId}`
            }
            const res = await this.$app.listdata('/hygl/ytRecord/listdata', param)

            if (res.code === 'success') {
                this.changeIdx = 0
                this.bodyFileUrl = ''
                this.attachmentsList = res.body.pageInfo.list[0].passenger.attachments
                if (this.attachmentsList.length > 0) {
                    this.judgeFile = this.JudgeFileType(this.attachmentsList[0].fileName)
                    this.currentFileId = this.attachmentsList[0].id
                    let fileurl = process.env.VUE_APP_BASE_API + `/hygl/ytRecord/downloadById?inline=true&attachIds=${this.attachmentsList[0].id}` + '&widthType=pageWidth&viewType=mobile&topdf=true'
                    fileurl += '&httpPort=' + location.port + '&fileName=' + this.attachmentsList[0].fileName
                    this.bodyFileUrl = './plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl) + '&showDownLoadBtn=true'
                } else {
                    this.judgeFile = false
                }
                this.contentLoading = false
            } else {
                this.$message.error(res.message)
            }
        },
        // 更新议题汇报时长，计时器重现开始计时
        async hyapYtInfoUpdate() {
            this.isPaused = false
            this.openHbShow = true
            clearInterval(this.intervalId)
            this.hyytRow.sjReportTime = this.formattedTime
            this.hyytRow.meetingStatus = 1
            this.tableData[this.currentIndex].sjReportTime = this.formattedTime
            this.tableData[this.currentIndex].meetingStatus = 1

            await this.$http({
                method: 'put',
                url: 'hygl/ytRecord/update',
                data: this.hyytRow,
                params: {hyapId: this.hyapId}
            }).then((res) => {
                if (res.code === 'success') {
                    // do nothing
                    // this.getListData()
                }
            })
        },
        // 切换议题
        async changeHandler(type) {
            var _this = this
            this.contentLoading = true

            clearInterval(this.intervalId)
            if (this.listType !== 'history') {
                if (_this.hyytRow.meetingStatus == 1 && !this.isPaused) {
                    await this.hyapYtInfoUpdate()
                }
            }

            this.controlBtn(type)

            setTimeout(() => {
                this.hyytRow = this.tableData[this.currentIndex]

                _this.currentTime = 0
                _this.pauseTime = 0
                _this.tyPauseTime = this.hyytRow.sjReportTime ? this.getReportTime(this.hyytRow.sjReportTime) : 0
                _this.currentTime = _this.tyPauseTime
                if (_this.hyytRow.meetingStatus != 1) { // 待上会
                    _this.isPaused = true
                    _this.pauseBtn = true
                    _this.pause()
                } else { //已上会
                    _this.isPaused = false
                    _this.pauseBtn = false
                    _this.pause()
                }

                this.attachmentsList = this.hyytRow.passenger.attachments

                this.changeIdx = 0
                this.bodyFileUrl = ''
                if (this.attachmentsList.length > 0) {
                    this.judgeFile = this.JudgeFileType(this.attachmentsList[0].fileName)
                    this.currentFileId = this.attachmentsList[0].id
                    let fileurl = process.env.VUE_APP_BASE_API + `/hygl/ytRecord/downloadById?inline=true&attachIds=${this.attachmentsList[0].id}` + '&widthType=pageWidth&viewType=mobile&topdf=true'
                    fileurl += '&httpPort=' + location.port + '&fileName=' + this.attachmentsList[0].fileName
                    this.bodyFileUrl = './plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl) + '&showDownLoadBtn=true'
                } else {
                    this.judgeFile = false
                }

                this.contentLoading = false
            }, 100)
        },
        // 获取 汇报时间（格式 xx:xx  分:秒）的毫秒数
        getReportTime(reportTime) {
            // if (!reportTime) {
            //     return 0
            // }
            // const [minutes, seconds] = reportTime.split(':')
            // return parseInt(minutes) * 60 * 1000 + parseInt(seconds) * 1000

            if (!reportTime) {
                return 0
            }
            const [minutes, seconds] = reportTime.split(':')
            return parseInt(minutes) * 60 + parseInt(seconds)
        },
        // 控制上下议题按钮
        controlBtn(type) {
            this.isLastBtn = false
            this.isNextBtn = false

            if (type === 'last') {
                this.currentIndex = (this.currentIndex - 1) % this.tableData.length // 切换到上一条数据
            } else if (type === 'next') {
                this.currentIndex = (this.currentIndex + 1) % this.tableData.length // 切换到下一条数据
            }

            if (this.currentIndex <= 0) {
                this.isLastBtn = true
                this.currentIndex = 0
            }
            if (this.currentIndex >= this.tableData.length - 1) {
                this.isNextBtn = true
                this.currentIndex = this.tableData.length - 1
            }
        },
        close() {
            window.close()
        },
        // 下载文件
        downloadFile(url) {
            const downUrl = process.env.VUE_APP_BASE_API + `/hygl/hyap/downloadById?attachIds=${this.currentFileId}`
            window.open(downUrl, '_self')
        },
        getListData(vo) {
            this.$http({
                method: 'post',
                url: '/hygl/ytRecord/listdata',
                params: {
                    pageSize: 9999,
                    pageNum: 1,
                    urlsearch: `meetDirectoryId:${this.vo.ytId}`,
                    orderBy: 'orderNo asc'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.tableData = res.body.pageInfo.list
                    let time = 0
                    this.tableData.forEach((item) => {
                        if (item.reportTime) {
                            time += item.reportTime
                        }
                        if (item.talkTime) {
                            time += item.talkTime
                        }
                    })
                    this.allTime = time
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
/deep/.el-table__body-wrapper::-webkit-scrollbar {
    height: 8px;
}
/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 12px; /*滚动条的背景区域的圆角*/
}
/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 12px; /*滚动条的圆角*/
    background-color: #f5f5f5; /*滚动条的背景颜色*/
}
/deep/.el-form .el-table__body .tdlbl {
    background: transparent !important;
}
#new-busi-form {
    height: 100%;
    background: #f0f2f5;
    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        background: white;
        align-items: center;
        .head-left {
            display: flex;
            align-items: center;
            img {
                width: 44px;
                height: 44px;
            }
            .head-title {
                margin-left: 10px;
                font-size: 14px;
                color: #999999;
            }
        }
    }
    .busi-box {
        height: calc(100% - 68px);
        overflow: scroll;
        padding-top: 20px;
        .busi-content {
            width: 100%;
            padding: 20px;
            background: white;
            min-height: calc(100vh - 108px);
            margin: 0px auto;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
            .title-info {
                height: 93px;
                text-align: center;
                line-height: 93px;
                font-size: 24px;
                color: #000000;
            }
            .busi-components {
                padding: 0 100px;
            }
        }
    }
    /* 设置滚动条thumb（轨道）的颜色 */
    .busi-box::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }
    /* 设置滚动条thumb（滑块）的颜色 */
    .busi-box::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }
    /* 设置滚动条hover时thumb的颜色 */
    .busi-box:hover.busi-box::-webkit-scrollbar-thumb {
        background-color: #d5d6d8;
    }
    /deep/.el-table .el-table__header-wrapper .el-table__header thead th {
        background: transparent !important;
    }
}

.time {
    width: 110px;
    height: 110px;
    border-radius: 65px;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0 0 11px 2px #bfcbd9;
    position: absolute;
    left: 100px;
    bottom: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;
    &:hover {
      transform: scale(1.02);
    }
}

.attach_son {
    line-height: 40px;
    padding: 0 15px;
    padding-right: 0;
    border-bottom: 1px solid #f0f3f9;
    font-size: 14px;
    word-break: break-all;
    cursor: pointer;
}
.changeClass {
    color: #fff;
    // border-left: 2px solid #BF165E;
    background-color: var(--subjectColor);
}
.box {
    width: 300px;
}

/* 定义左侧 div 的过渡效果 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

</style>
